import React, { useState } from 'react'

import styled from 'styled-components';
import TitleRowItem from '../../../../kosherTeudot/generic/TitleRowItem';
import TitleLayout from '../../../../kosherTeudot/generic/TitleLayout';
import TitleRow from '../../../../kosherTeudot/generic/TitleRow';
import PrintIcon from '../../../../../../../generic/icons/IconLib/PrintIcon';

interface IDropdownWrapperProps {
  title: string;
  icon: React.ReactElement;
  children: React.ReactNode | React.ReactNode[];
  handlePrint?: () => void;
}

const DropdownWrapper = (props: IDropdownWrapperProps) => {
  const { title, icon, children, handlePrint } = props;
  const [isOpenNested, setIsOpenNested] = useState(false);
  const handleToggleNested = () => {
    setIsOpenNested(!isOpenNested);
  }
  const handlePrintFunc = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    handlePrint?.();
  }
  return (
    <MainWrapper $isOpen={isOpenNested}>
      <ClickableTitleContainer onClick={handleToggleNested}>
        <TitleLayout>
          {
            handlePrint && (
              <PrintButton
                onClick={handlePrintFunc}
              >
                <PrintIcon />
              </PrintButton>
            )
          }
          <TitleRow>
            <TitleRowItem name={title.trim()} icon={icon} />
            <ExpandArrow $isOpen={isOpenNested}>▼</ExpandArrow>
          </TitleRow>
        </TitleLayout>
      </ClickableTitleContainer>
      <ListWrapper $isVisible={isOpenNested}>
        {children}
      </ListWrapper>
    </MainWrapper>
  )
}
const MainWrapper = styled.div<{ $isOpen: boolean }>`
  width: 100%;
  display: flex;
  padding: 0.2em;
  flex-direction: column;
  transition: all 0.2s ease;
  background-color: ${props => props.$isOpen ? '#e9ecef' : 'none'};
  border-radius: 20px;
  direction: ltr;
`;

const ClickableTitleContainer = styled.div`
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
  padding: 0.2em;
`;

const ExpandArrow = styled.span<{ $isOpen: boolean }>`
  font-size: 0.9em;
  color: #297f76;
  transform: rotate(${props => (props.$isOpen ? "180deg" : "0deg")});
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-right: 0.8em;
  user-select: none;
  align-self: center;
  opacity: 0.8;

  &:hover {
    opacity: 1;
}
`;
const ListWrapper = styled.div<{ $isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.2em;
  border-radius: 30px 30px 17px 17px;
  max-height: ${props => props.$isVisible ? '2000px' : '0'};
  opacity: ${props => props.$isVisible ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: ${props => props.$isVisible ? '0.5em' : '0'};
`;

const PrintButton = styled.div`
  position: absolute;
  top: 0.65em;
  left: 0.5em;
  width: 2em;
  height: 2em;
  color: #297f76;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    color: #297f76;
    transform: scale(1.1);

  }
`;
export default DropdownWrapper